import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon-website"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
    >
      <path d="M1000 500A501 501 0 0 0 503 0h-6A501 501 0 0 0 0 500c0 275 223 499 498 500h4a501 501 0 0 0 498-500zM529 936V765h133c-31 90-79 154-133 171zM337 765h134v171c-54-17-101-81-134-171zM61 539h176a899 899 0 0 0 22 167H110a439 439 0 0 1-49-166zM471 64v191H331c31-101 82-173 140-191zm199 191H529V64c58 18 109 90 140 191zm270 226H763c-1-59-7-115-18-167h155a438 438 0 0 1 40 167zm-235 0H529V314h156a857 857 0 0 1 19 167zM471 314v167H296a859 859 0 0 1 19-167h156zM237 481H60a438 438 0 0 1 41-167h154a921 921 0 0 0-18 167zm59 58h175v167H320a837 837 0 0 1-24-166zm233 167V539h175a831 831 0 0 1-24 167H529zm234-166h176a436 436 0 0 1-49 166H741a893 893 0 0 0 22-166zm104-285H731c-20-68-47-126-81-169a443 443 0 0 1 217 169zM350 86c-33 43-61 101-81 169H133A443 443 0 0 1 350 86zM148 765h127c20 59 45 110 75 150a442 442 0 0 1-202-150zm502 150c30-39 56-91 75-150h127a442 442 0 0 1-202 150z" />
    </svg>
  );
}
